import { createCrud } from '@lumahealthhq/ui-model';
var basePath = 'squigglies';
var crud = createCrud(basePath);

/* Default queries */
export var useSquigglyOne = crud.makeFindOne();